/**
 * Run scripts on document ready
 */

/* global dcawCompare */
/* global dcawGeneral */

import NiceSelect from "nice-select2";

import Compare from "./compare";
import dropdown from "./dropdown";
import modalHub from "./modal/";
document.addEventListener("DOMContentLoaded", () => {
  const compareModal = modalHub(".compare-modal");
  if (compareModal) {
    compareModal.init();
  }
  dropdown.mount();

  if (typeof dcawCompare === "object" && typeof dcawGeneral === "object") {
    const compare = new Compare({ ...dcawGeneral, ...dcawCompare });

    compare.mount();
  }
});

const selectElement = document.getElementById("category-filter");
if (selectElement && typeof NiceSelect === "function") {
  new NiceSelect(selectElement, {});
} else {
  console.warn("NiceSelect is not available or not a constructor.");
}
